module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2-left"
  }, [_c('a', {
    attrs: {
      "id": "ch03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Three")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("I")]), _vm._v(" shut off the engine and look up at my house. It’s dark, except for the light in the kitchen, the one left on to scare away robbers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Tap. Tap. Tap")]), _vm._v(". I jump. Hanna’s face peers at me through the car window. Her brown hair is pulled back into a high ponytail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What the hell?” I open the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nice seeing you, too, Mr. Grumpy Pants.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nods, the sign for me to follow. I know I only have one choice, so I head after her. If I don’t, I’ll hear about it by not hearing about it, and Hanna’s silent treatment is almost as bad as hearing about it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("I glance at my house. No movement. That’s good. It means ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("the parentals are still asleep. In a couple of strides, I’m even with her.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Couldn’t sleep?” she whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shrug. She knows I go somewhere. She knows I come back. That’s about it. And that’s all she needs to know. I’m sure Hanna has her suspicions, but we don’t discuss them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Steve’s over.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh.” Steve is her mom’s boyfriend, some super-off-the-chart-brainiac designer who works at JPL, as in Jet Propulsion Laboratory. They do all kinds of high-tech things, like make spacecrafts and send them to Mars. He’s decent, but it’s got to be weird knowing your mom’s having sex with the guy just a few doors down from your room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Want to stay at my house?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks at me funny. “Yeah, I’m sure your parents would go for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? I’ll sneak you out before they even wake up. They sleep in on Saturdays. Besides, it’s not like you haven’t stayed over before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“True, but . . .”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("“Right,” I say. I know what she’s thinking. Hanna used to have sleepovers with Grace, which made more sense. We are all—no, we "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("were")]), _vm._v(" all—the same age: Grace and me sharing the ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("same birthday because of the whole twin thing, and Hanna only a couple of months younger than us. We would all hang out until it was time for bed, and then I’d hear the two of them giggling through the wall between our bedrooms. Alone on the other side, I always wondered what they were laughing about, jealous that I wasn’t in on the joke.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hanna and I walk in the dark because there are no streetlights. The neighborhood is quiet. No one is peeking out at us through slightly parted curtains. Most people are asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or we could just stay up all night,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Up all night? I have nothing going on tomorrow—today, actually—except a couple hours of bass practice. I could technically lose a night and still make it up before school starts. It’s not like I sleep much anyway. Chris gave me something to help, but it didn’t. I needed a brain wipe, not a sleeping pill. So instead I walk the bridge, or I put on headphones and plug in my electric bass and play until it’s morning. I probably wouldn’t get any sleep tonight. Besides, Hanna and I are overdue for an all-nighter, so I agree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hanna opens the gate that leads to her backyard. She tries to be quiet, but the hinges let out a slow whine. She freezes and her green eyes look at me all huge as if we’ve just been busted.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("We wait, but nothing happens. There’s no Mom or Steve checking to see who’s breaking in. We tiptoe over to a large ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("wooden swing hanging from a huge oak toward the back of her yard.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I sit on the swing first, holding it still so Hanna can sit next to me. She’s in her pj’s: a pink shirt and sweatpants. She rolls the waist down to rest just below her hips. I’m supposed to act like I don’t notice, but I do, every time. Just because we’ve grown up together doesn’t mean I don’t have a pulse. The white cord to her insulin pump, which she dubbed Pepe a couple of years ago, peeks out from underneath her shirt. She’s always complaining about having to wear Pepe, how it ruins her style, but it’s not like she has a choice. She was diagnosed with type 1 diabetes when she was six, and she has to keep a close eye on her sugar level.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Years ago, her mom walked Grace and me through what to do if Pepe started beeping and we needed to help her. I basically have to make her drink something high in sugar, like orange juice—that stuff is loaded. It can be funny when Hanna’s low because she acts kind of loopy and stubborn, but it can get scary real fast. She had a seizure two years ago and an ambulance had to take her to the hospital. I teased her about faking being sick so she could get attention when she came home, but I was worried about her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I glide the swing slowly back and forth with my feet. Hers don’t even touch the ground, so she pulls her legs up to her chest and hugs them with her arms.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("“What are you looking forward to the most?” she asks.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I smile. She knows "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("How are you")]), _vm._v("s are banned from conversation, but she’s always finding a way to ask without saying the words. I should mind, but I don’t. I kind of like that she checks in on me. “Tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, senior year, stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Graduating.” Not that I have any huge plans. I’m supposed to apply to music schools this fall. But I don’t know if that’s what I want anymore. I don’t know anything anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hanna punches me softly in the arm. “I’m being serious.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So am I.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m looking forward to all the lasts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The lasts?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Remember freshman year? When you started high school, there were all these firsts. This year, because it’s all ending, there’ll be all the lasts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m quiet, so she continues like she has to explain it to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, the last time you attend an opening year assembly, the last time you have to take math, the last time you go to a football game, the last time you ditch class to go shopping with your best friend . . .” Her voice wobbles and trails off. She doesn’t say Grace’s name, but I know that’s who she means. I stiffen next to her.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("To say Hanna and I are different is an understatement. Half ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("the time I don’t even try to pretend to understand her. She cries so easily, like at movies or when she hears about someone getting bad news or when she’s frustrated. Never sit in rush-hour traffic with her when she’s late.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She cried when she found out about Grace. She had come to the hospital and collapsed into her mom when Jenny told them. I watched her and felt nothing. I kind of envied her for making it look so easy. Hanna cried a few times and then it was over. It was as if all the painful stuff on the inside came out and she was fine. I didn’t know how she could do that, how she could just let it go. I didn’t cry when Grace died, still haven’t. I kind of went numb. At the funeral, I stood there amid all the tears, but I couldn’t do it. Everyone took my dry eyes as quiet stoicism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If I feel anything, most of the time it’s anger. Chris tried to get me to cry in his office, but all I could think about was how his widow’s peak came to such a sharp point in the middle of his forehead. It looked like a perfect arrow to direct my fist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hope Hanna doesn’t start crying now. I don’t think I can take it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Changing the subject, I ask, “Remember the first time we stayed up all night on this bench?” Though as soon as I say it, I kind of wish I could take it back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("“Eighth grade.” The year I got into the school for the arts. The year Hanna and I almost kissed.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dad moved out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nod, waiting for it to hit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You tried to kiss me.” She says softly. She’s looking at her toes. Her nails are some dark color.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("gave")]), _vm._v(" you a consolation hug. You were the one who turned your face as I bent down. In fact, I could say "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(" tried to kiss "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("me")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughs. “Oh man, that was embarrassing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I was embarrassed for you,” I tease.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shut up,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I push us faster on the swing, suddenly a little embarrassed for bringing it up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wasn’t embarrassed that night. I was confused. It was late and Hanna sent me a text about her dad and asked if I could come over. Normally she would have texted Grace, but Grace was in Long Beach visiting our mom. I wasn’t interested in spending two weeks with Mom and her new husband. Grace said I was being stubborn, for not wanting to go, but I didn’t care. In my opinion, Mom made her choice years ago when she left. I didn’t see the need to facilitate the façade, but Grace, well, she was the more forgiving one of us.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("So I ran over to Hanna’s and she was waiting for me in the backyard on the bench. She looked so small and scared sitting ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("there. She was crying. I sat next to her and listened to her talk about her parents, about how she couldn’t imagine life without her dad in the house.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My parents split up when Grace and I were seven. Mom left on a Friday after her nurse’s shift at the hospital. I remember because we had plans to go camping that weekend, and Dad made Grace and me stay at Tita Christie’s instead. We didn’t understand what had happened. I still don’t. All I know is that she left us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom gave Dad full custody and eventually met this guy Will and moved about an hour away. Dad married Jenny a couple years after the divorce. The funny thing is that they both fell for someone white, not that I have anything against white people. They probably figured they’d tried marrying a Filipino first, and since that had been a mess, why not?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I could relate to Hanna’s drama of screwed-up families. Most of the time our piecemeal family was cool. We did get Jenny out of the deal. When she first met us, Jenny brought me a CD of my favorite bass music and Grace some fancy colored pens. We liked her right away. At least I did. She knew about Edgar Meyer, an amazing bassist, and that gave her instant points. Later I found out that Dad had given Jenny the tip. Grace took a little longer to win over because I think she was still holding out for Mom to come home.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Sometimes it sucked. Mom and I still weren’t on the best ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("of terms. But I always had Grace. I never had to go through it alone, not like Hanna. She was the only kid. She had all the pressure of dealing with the hurt and her parents on her own.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hanna had a huge tear running down her face. I wanted to tell her that everything was going to be okay. No, I wanted to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("make")]), _vm._v(" everything okay for her. I reached out and wiped her cheek. I had never touched her that way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ll be okay,” I said, looking into her eyes, which were swollen around the lids, but still glossy and beautiful. She looked into mine and I wanted to kiss her. She wanted me to, because she moved a little closer and her eyes started to close. I knew what I was supposed to do. But this was different from playing truth or dare with Jessica. I’d only wanted one thing from Jessica last year. This was Hanna. The same Hanna I had been friends with since the fifth grade. The Hanna whom I knew as well as I did my sister. Hanna, who made me feel nervous and safe at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I panicked. I hesitated too long and broke the mood, so I pretended like I was just going to give her a hug.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We sat there all night, not talking, me with my arm around her, even after it started cramping. That’s when I got confused. I started to think I loved, or at least really liked, Hanna, because there was no one else I would sit up with all night long, not even Grace.")])]), _c('p', {
    staticClass: "secbreak"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("•  •  •  •")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I hope it’s a good year,” Hanna says. “I really need a good year.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ll have a great year,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course.” She pauses and adds, “There’s nothing to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("fear")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I rest the back of my head on the bench. “Depends on what’s near.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or if it’s all clear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hanna and I play the game that she, Grace, and I started years ago. Grace was usually the best. She had an ear for rhyme. She’d write these amazing poems, so it really wasn’t fair to play with her. It was never stacked in our favor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tonight I win because it’s only Hanna and me now, and I’m the last one awake. I don’t mind that her head has fallen on my shoulder. She smells like Hanna, a little bit of sweat and ivory soap. I put my arm around her and rock us slowly back and forth on the swing. It’s almost morning, but I don’t want to wake her. I want to stay here as long as possible. I listen to her steady breathing and watch the orange glow of dawn creep over us and cover the sky like a blanket.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18b27f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 69
// module chunks = 0